<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-08-18 19:53:04
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="content">
        <div class="pageTitle">总部统计 （统计数据非实时统计，更新截止到前一天）</div>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick1">
            <el-tab-pane label="入库统计" name="first">
                <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
                    <el-form-item label="入库时间:" style="text-align: center">
                        <el-col :span="11">
                            <el-date-picker type="date" placeholder="开始时间" v-model="form1.start_time"
                                            style="width: 100%;"></el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-date-picker type="date" placeholder="结束时间" v-model="form1.end_time"
                                            style="width: 100%;"></el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="产品编号:">
                        <el-input v-model="form1.product_sn" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="产品名称:">
                        <el-input v-model="form1.product_name" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="生产批次号:">
                        <el-input v-model="form1.production_batch" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="入库单号:">
                        <el-input v-model="form1.stock_in_sn" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="入库仓库:">
                        <el-select v-model="form1.warehouse_sn" placeholder="请选择入库仓库">
                            <el-option key="" label="全部" value=""></el-option>
                            <el-option v-for=" i in stockArray" :key="i.warehouse_sn" :label="i.warehouse_name"
                                       :value="i.warehouse_sn"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getInstockData()">搜索</el-button>
                        <el-button @click="instockExport()" >导出</el-button>
                    </el-form-item>
                </el-form>
                <span style="margin-left: 40px;margin-right: 10px">应入库总数：</span><span style="color: red;">{{stock_in_num}}</span>
                <span style="margin-left: 20px;margin-right: 10px">实际入库总数：</span><span style="color: red;">{{real_stock_in_num}}</span>
                <!--表格-->
                <el-table
                        ref="multipleTable"
                        :data="tableData1"
                        v-loading="loading"
                        border
                        stripe
                        style="width: 100%;margin-top: 20px">
                    <el-table-column
                            label="序号"
                            type="index"
                            width="100"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="product_sn"
                            label="产品编号"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="product_name"
                            label="产品名称"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="product_specs"
                            label="规格"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="real_stock_in_num"
                            label="入库数量"
                            show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column
                            prop=""
                            label="操作"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="instockDetail(scope.row)">明细</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页-->
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="pageNo1"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pageSize1"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize1">
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="出库统计" name="second">
                <el-tabs v-model="activeChildone" type="card" @tab-click="handleClick2">
                    <el-tab-pane label="总部出货统计(经销商/门店)" name="second_first">
                        <el-form ref="form2" :model="form2" label-width="120px" :inline="true">
                            <el-form-item label="出库时间:" style="text-align: center">
                                <el-col :span="11">
                                    <el-date-picker type="date" placeholder="开始时间" v-model="form2.start_time"
                                                    style="width: 100%;"></el-date-picker>
                                </el-col>
                                <el-col class="line" :span="2">-</el-col>
                                <el-col :span="11">
                                    <el-date-picker type="date" placeholder="结束时间" v-model="form2.end_time"
                                                    style="width: 100%;"></el-date-picker>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="出库单号:">
                                <el-input v-model="form2.stock_out_sn" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="是否赠品:">
                                <el-select v-model="form2.isgift" placeholder="请选择入库仓库">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option label="赠品" value="1"></el-option>
                                    <el-option label="非赠品" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="出货仓库:">
                                <el-select v-model="form2.warehouse_sn">
                                    <el-option key="" label="全部" value=""></el-option>
                                    <el-option v-for=" i in stockArray" :key="i.warehouse_sn" :label="i.warehouse_name"
                                               :value="i.warehouse_sn"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="经销商/门店:">
                                <el-col :span="12">
                                    <el-input v-model="form2.to_sn" clearable readonly></el-input>
                                </el-col>
                                <el-col :span="4" style="margin-left: 10px;">
                                    <el-button type="primary" @click="selectType()">选择</el-button>
                                </el-col>

                            </el-form-item>
                            <el-form-item label="产品编号:">
                                <el-input v-model="form2.product_sn" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="产品名称:">
                                <el-input v-model="form2.product_name" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="生产批次号:">
                                <el-input v-model="form2.production_batch" clearable></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="getOutstockDealerData()">搜索</el-button>
                                <el-button type="primary" @click="dealerOutstockExport()">导出</el-button>
                            </el-form-item>
                        </el-form>
                        <span style="margin-left: 40px;margin-right: 10px">总出货数：</span><span
                            style="color: red;">{{real_stock_out_num1}}</span>
                        <el-table
                                ref="multipleTable"
                                :data="tableData2"
                                v-loading="loading"
                                border
                                style="width: 100%;margin-top: 20px">
                            <el-table-column
                                    label="序号"
                                    width="100"
                                    type="index"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="to_name"
                                    label="经销商/门店名称"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="to_sn"
                                    label="经销商/门店编号"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop="real_stock_out_num"
                                    label="出货数量"
                                    show-overflow-tooltip>
                            </el-table-column>

                            <el-table-column
                                    prop=""
                                    label="操作"
                                    show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="outstockDetailCust(scope.row)">明细
                                    </el-button>
                                </template>
                            </el-table-column>


                        </el-table>
                        <!--分页-->
                        <el-pagination
                                style="margin: 20px 0"
                                @size-change="handleSizeChange2"
                                @current-change="handleCurrentChange2"
                                :current-page="pageNo2"
                                :page-sizes="[20, 50, 100, 200]"
                                :page-size="pageSize2"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalSize2">
                        </el-pagination>
                    </el-tab-pane>
                    <el-tab-pane label="总部出货统计(产品)" name="second_second">
                        <el-form ref="form3" :model="form3" label-width="120px" :inline="true">
                            <el-form-item label="出库时间:" style="text-align: center">
                                <el-col :span="11">
                                    <el-date-picker type="date" placeholder="开始时间" v-model="form3.start_time"
                                                    style="width: 100%;"></el-date-picker>
                                </el-col>
                                <el-col class="line" :span="2">-</el-col>
                                <el-col :span="11">
                                    <el-date-picker type="date" placeholder="结束时间" v-model="form3.end_time"
                                                    style="width: 100%;"></el-date-picker>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="经销商/门店:">
                                <el-col :span="12">
                                    <el-input v-model="form3.to_sn" clearable readonly></el-input>
                                </el-col>
                                <el-col :span="4" style="margin-left: 10px;">
                                    <el-button type="primary" @click="selectType()">选择</el-button>
                                </el-col>

                            </el-form-item>
                            <el-form-item label="出货仓库:">
                                <el-select v-model="form3.warehouse_sn" placeholder="请选择入库仓库">
                                    <el-option key="" label="全部" value=""></el-option>
                                    <el-option v-for=" i in stockArray" :key="i.warehouse_sn" :label="i.warehouse_name"
                                               :value="i.warehouse_sn"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="产品代码:">
                                <el-input v-model="form3.product_sn" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="产品名称:">
                                <el-input v-model="form3.product_name" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="批号:">
                                <el-input v-model="form3.production_batch" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="出库单号:">
                                <el-input v-model="form3.stock_out_sn" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="是否赠品:">
                                <el-select v-model="form3.isgift">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option label="赠品" value="1"></el-option>
                                    <el-option label="非赠品" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="getOutstockGoodsData()">搜索</el-button>
                                <el-button type="primary" @click="productOutstockExport()">导出</el-button>
                            </el-form-item>
                        </el-form>
                        <span style="margin-left: 40px;margin-right: 10px">总数量：</span><span
                            style="color: red;">{{real_stock_out_num2}}</span>
                        <el-table
                                ref="multipleTable"
                                :data="tableData3"
                                v-loading="loading"
                                border
                                style="width: 100%;margin-top: 20px">
                            <el-table-column
                                    label="序号"
                                    width="100"
                                    type="index"
                                    fixed
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="product_sn"
                                    label="产品代码"
                                    fixed>
                            </el-table-column>
                            <el-table-column
                                    prop="product_name"
                                    label="产品名称"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop="product_specs"
                                    label="规格"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop="real_stock_out_num"
                                    label="出库数量"
                                    show-overflow-tooltip>
                            </el-table-column>

                            <el-table-column
                                    prop=""
                                    label="操作"
                                    show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="outstockDetailGoods(scope.row)">明细
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                                style="margin: 20px 0"
                                @size-change="handleSizeChange3"
                                @current-change="handleCurrentChange3"
                                :current-page="pageNo3"
                                :page-sizes="[20, 50, 100, 200]"
                                :page-size="pageSize3"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalSize3">
                        </el-pagination>
                    </el-tab-pane>
                </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="退货统计" name="third">
                <el-tabs v-model="activeChildtwo" type="card" @tab-click="handleClick3">
                    <el-tab-pane label="经销商/门店退货统计" name="third_first">
                        <el-form ref="form4" :model="form4" label-width="120px" :inline="true">
                            <el-form-item label="退货时间:" style="text-align: center">
                                <el-col :span="11">
                                    <el-date-picker type="date" placeholder="开始时间" v-model="form4.start_time"
                                                    style="width: 100%;"></el-date-picker>
                                </el-col>
                                <el-col class="line" :span="2">-</el-col>
                                <el-col :span="11">
                                    <el-date-picker type="date" placeholder="结束时间" v-model="form4.end_time"
                                                    style="width: 100%;"></el-date-picker>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="退货单号:">
                                <el-input v-model="form4.return_goods_sn" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="产品编号:">
                                <el-input v-model="form4.product_sn" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="产品名称:">
                                <el-input v-model="form4.product_name" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="是否赠品:">
                                <el-select v-model="form4.isgift" placeholder="请选择入库仓库">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option label="赠品" value="1"></el-option>
                                    <el-option label="非赠品" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="经销商/门店:">
                                <el-col :span="12">
                                    <el-input v-model="form4.from_sn" clearable readonly></el-input>
                                </el-col>
                                <el-col :span="4" style="margin-left: 10px;">
                                    <el-button type="primary" @click="selectType()">选择</el-button>
                                </el-col>

                            </el-form-item>
                            <el-form-item label="退往仓库:">
                                <el-select v-model="form4.warehouse_sn" placeholder="请选择入库仓库">
                                    <el-option key="" label="全部" value=""></el-option>
                                    <el-option v-for=" i in stockArray" :key="i.warehouse_sn" :label="i.warehouse_name"
                                               :value="i.warehouse_sn"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="getRefundDealerData()">搜索</el-button>
                                <el-button type="primary" @click="refundDealerExport()">导出</el-button>
                            </el-form-item>
                        </el-form>
                        <span style="margin-left: 40px;margin-right: 10px">总退货数：</span><span
                            style="color: red;">{{real_return_goods_num}}</span>
                        <el-table
                                ref="multipleTable"
                                v-loading="loading"
                                :data="tableData4"
                                border
                                style="width: 95%;margin-top: 20px">
                            <el-table-column
                                    label="序号"
                                    width="100"
                                    type="index"
                                    fixed
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="from_name"
                                    label="退货客户名称"
                                    fixed>
                            </el-table-column>
                            <el-table-column
                                    prop="from_sn"
                                    label="退回客户代码"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop="real_return_goods_num"
                                    label="退货数量"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop=""
                                    label="操作"
                                    show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="refundDetailCust(scope.row)">明细
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!--分页-->
                        <el-pagination
                                style="margin: 20px 0"
                                @size-change="handleSizeChange4"
                                @current-change="handleCurrentChange4"
                                :current-page="pageNo4"
                                :page-sizes="[20, 50, 100, 200]"
                                :page-size="pageSize4"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalSize4">
                        </el-pagination>
                    </el-tab-pane>
                    <el-tab-pane label="产品退货统计" name="third_second">
                        <el-form ref="form5" :model="form5" label-width="120px" :inline="true">
                            <el-form-item label="退货时间:" style="text-align: center">
                                <el-col :span="11">
                                    <el-date-picker type="date" placeholder="开始时间" v-model="form5.start_time"
                                                    style="width: 100%;"></el-date-picker>
                                </el-col>
                                <el-col class="line" :span="2">-</el-col>
                                <el-col :span="11">
                                    <el-date-picker type="date" placeholder="结束时间" v-model="form5.end_time"
                                                    style="width: 100%;"></el-date-picker>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="退货单号:">
                                <el-input v-model="form5.return_goods_sn" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="产品名称:">
                                <el-input v-model="form5.product_name" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="产品代码:">
                                <el-input v-model="form5.product_sn" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="经销商/门店:">
                                <el-col :span="12">
                                    <el-input v-model="form5.from_sn" clearable readonly></el-input>
                                </el-col>
                                <el-col :span="4" style="margin-left: 10px;">
                                    <el-button type="primary" @click="selectType()">选择</el-button>
                                </el-col>

                            </el-form-item>
                            <el-form-item label="是否赠品:">
                                <el-select v-model="form5.isgift" placeholder="请选择入库仓库">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option label="赠品" value="1"></el-option>
                                    <el-option label="非赠品" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="退往仓库:">
                                <el-select v-model="form5.warehouse_sn" placeholder="请选择入库仓库">
                                    <el-option key="" label="全部" value=""></el-option>
                                    <el-option v-for=" i in stockArray" :key="i.warehouse_sn" :label="i.warehouse_name"
                                               :value="i.warehouse_sn"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="getRefundGoodsData()">搜索</el-button>
                                <el-button type="primary" @click="refundGoodsExport()">导出</el-button>
                            </el-form-item>
                        </el-form>
                        <span style="margin-left: 40px;margin-right: 10px">总数量：</span><span
                            style="color: red;">{{real_return_goods_num}}</span>
                        <el-table
                                ref="multipleTable"
                                :data="tableData5"
                                v-loading="loading"
                                border
                                style="width: 95%;margin-top: 20px">
                            <el-table-column
                                    label="序号"
                                    width="100"
                                    type="index"
                                    fixed
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="product_sn"
                                    label="产品代码"
                                    fixed>
                            </el-table-column>
                            <el-table-column
                                    prop="product_name"
                                    label="产品名称"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop="product_specs"
                                    label="规格"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop="real_return_goods_num"
                                    label="数量"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop=""
                                    label="操作"
                                    show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="refundDetailGoods(scope.row)">明细
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                                style="margin: 20px 0"
                                @size-change="handleSizeChange5"
                                @current-change="handleCurrentChange5"
                                :current-page="pageNo5"
                                :page-sizes="[20, 50, 100, 200]"
                                :page-size="pageSize5"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalSize5">
                        </el-pagination>
                    </el-tab-pane>
                </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="库存统计" name="fourth">
                <el-form ref="form6" :model="form6" label-width="120px" :inline="true">
                    <el-form-item label="生产批次号:">
                        <el-input v-model="form6.production_batch" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="入库单号:">
                        <el-input v-model="form6.stock_in_sn" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="产品名称:">
                        <el-input v-model="form6.product_name" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="产品编号:">
                        <el-input v-model="form6.product_sn" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getStockData()">搜索</el-button>
                        <el-button type="primary" @click="stockExport()">导出</el-button>
                    </el-form-item>
                </el-form>
                <span style="margin-left: 40px;margin-right: 10px">总入库数目：</span><span style="color: red;">{{base_real_stock_in_num}}</span>
                <span style="margin-left: 40px;margin-right: 10px">总出库数目：</span><span style="color: red;">{{base_real_stock_out_num}}</span>
                <span style="margin-left: 40px;margin-right: 10px">总退货数目：</span><span style="color: red;">{{base_real_return_goods_num}}</span>
                <el-table
                        ref="multipleTable"
                        v-loading="loading"
                        :data="tableData6"
                        border
                        style="width: 100%;margin-top: 20px">
                    <el-table-column
                            label="序号"
                            width="100"
                            type="index"
                            fixed
                    >
                    </el-table-column>
                    <el-table-column
                            prop="product_sn"
                            label="产品编号"
                            fixed>
                    </el-table-column>
                    <el-table-column
                            prop="product_name"
                            label="产品名称"
                          >
                    </el-table-column>
                    <el-table-column
                            prop="product_specs"
                            label="规格"
                           >
                    </el-table-column>
                    <el-table-column
                            prop="real_stock_in_num"
                            label="入库数量"
                           >
                    </el-table-column>
                    <el-table-column
                            prop="real_stock_out_num"
                            label="出库数量"
                           >
                    </el-table-column>
                    <el-table-column
                            prop="real_return_goods_num"
                            label="退货数量"
                           >
                    </el-table-column>
                    <el-table-column
                            prop="surplus_num"
                            label="剩余数量"
                          >
                    </el-table-column>
                </el-table>
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange6"
                        @current-change="handleCurrentChange6"
                        :current-page="pageNo6"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pageSize6"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize6">
                </el-pagination>
            </el-tab-pane>
        </el-tabs>
        <!--选择经销商/门店-->
        <selectRole
                v-if="selectRoleDialog"
                v-on:handleClose='selectRoleDialog = false'
                @pushData="getCust">
        </selectRole>
        <!--总部入库统计明细-->
        <instockDetailDialog
                v-if="instockDetailDialogVisable"
                v-on:handleClose='instockDetailDialogVisable = false'
                :stock_in_sn="stock_in_sn">

        </instockDetailDialog>
        <!--总部出货统计(经销商/门店)-->
        <outDetailDialogCust
                v-if="outDetailDialogCustVisable"
                v-on:handleClose='outDetailDialogCustVisable = false'
                :detaiData="detaiData"
                :filters="form2">
        </outDetailDialogCust>
        <!--总部出货统计(产品)-->
        <outDetailDialogGoods
                v-if="outDetailDialogGoodsVisable"
                v-on:handleClose='outDetailDialogGoodsVisable = false'
                :product_sn="product_sn">
        </outDetailDialogGoods>
        <!--退货（经销商/门店）明细-->
        <refundDetailDialogCust
                v-if="refundDetailDialogCustVisable"
                v-on:handleClose='refundDetailDialogCustVisable = false'
                :refundCustData="refundCustData">
        </refundDetailDialogCust>
        <!--退货产品明细-->
        <refundDetailDialogGoods
                v-if="refundDetailDialogGoodsVisable"
                v-on:handleClose='refundDetailDialogGoodsVisable = false'
                :refund_sn="refund_sn"
        >
        </refundDetailDialogGoods>
        <!--总部库存统计明细-->
        <stockDetailDialog
                v-if="stockDetailDialogVisable"
                v-on:handleClose='stockDetailDialogVisable = false'>
        </stockDetailDialog>

    </div>

</template>
<script>
    import selectRole from '../../common/selectRole';
    import instockDetailDialog from './dialogs/instockDetailDialog';
    import outDetailDialogCust from './dialogs/outstockDetailDialogCust';
    import outDetailDialogGoods from './dialogs/outstockDetailDialogGoods';
    import refundDetailDialogCust from './dialogs/refundDetailDialogCust';
    import refundDetailDialogGoods from './dialogs/refundDetailDialogGoods';
    import stockDetailDialog from './dialogs/stockDetailDialog';

    export default {
        name: "base-count",
        data() {
            return {
                loading:false,
                selectRoleDialog: false,
                instockDetailDialogVisable: false,//入库明细
                outDetailDialogCustVisable: false,//出库客户明细
                outDetailDialogGoodsVisable: false,//出库产品明细
                refundDetailDialogCustVisable: false,//退货客户明细
                refundDetailDialogGoodsVisable: false,//退货产品明细
                stockDetailDialogVisable:false,//库存统计明细
                activeName: 'first',
                activeChildone: 'second_first',
                activeChildtwo: 'third_first',
                stockArray:'',//仓库
                form1: {
                    start_time:'',
                    end_time:'',
                    warehouse_sn:'',
                    stock_in_sn:'',
                    product_sn:'',
                    product_name:'',
                    production_batch:''
                },
                stock_in_num:'',//应入库总数
                real_stock_in_num:'',//实际入库总数
                form2: {
                    start_time:'',
                    end_time:'',
                    warehouse_sn:'',
                    isgift:'',
                    to_type:'',
                    to_sn:'',
                    stock_out_sn:'',
                    product_sn:'',
                    product_name:'',
                    production_batch:''
                },
                real_stock_out_num1:'',//实际出库总数
                real_stock_out_num2:'',//实际出库总数
                detaiData:{},//经销商/门店客户列表明细传的数据
                form3: {
                    start_time:'',
                    end_time:'',
                    warehouse_sn:'',
                    isgift:'',
                    to_type:'',
                    to_sn:'',
                    stock_out_sn:'',
                    product_sn:'',
                    product_name:'',
                    production_batch:''
                },
                product_sn:'',//产品编号传给自页面
                form4: {
                    start_time:'',
                    end_time:'',
                    warehouse_sn:'',
                    isgift:'',
                    from_type:'',
                    from_sn:'',
                    return_goods_sn:'',
                    product_sn:'',
                    product_name:'',
                    production_batch:''
                },
                real_return_goods_num:'',
                form5: {
                    start_time:'',
                    end_time:'',
                    warehouse_sn:'',
                    isgift:'',
                    from_type:'',
                    from_sn:'',
                    return_goods_sn:'',
                    product_sn:'',
                    product_name:'',
                    production_batch:''
                },
                form6: {
                    product_sn:'',
                    product_name:'',
                    stock_in_sn:'',
                    production_batch:''
                },
                base_real_return_goods_num:'',
                base_real_stock_in_num:'',
                base_real_stock_out_num:'',
                tableData1: [],
                stock_in_sn:'',//入库明细传递参数
                tableData2: [],
                tableData3: [],
                tableData4: [],
                tableData5: [],
                refund_sn:'',//传给明细
                tableData6: [],
                //分页
                pageNo1: 1,
                pageSize1: 20,
                totalSize1: 0,

                pageNo2: 1,
                pageSize2: 20,
                totalSize2: 0,

                pageNo3: 1,
                pageSize3: 20,
                totalSize3: 0,

                pageNo4: 1,
                pageSize4: 20,
                totalSize4: 0,

                pageNo5: 1,
                pageSize5: 20,
                totalSize5: 0,

                pageNo6: 1,
                pageSize6: 20,
                totalSize6: 0,

            }
        },
        methods: {
            getLastMonth() {
                var now = new Date();
                var year = now.getFullYear();//getYear()+1900=getFullYear()
                var month = now.getMonth() + 1;//0-11表示1-12月
                var day = now.getDate();
                var dateObj = {};
                if (parseInt(month) < 10) {
                    month = "0" + month;
                }
                if (parseInt(day) < 10) {
                    day = "0" + day;
                }

                dateObj.now = year + '-' + month + '-' + day;

                if (parseInt(month) == 1) {//如果是1月份，则取上一年的12月份
                    dateObj.last = (parseInt(year) - 1) + '-12-' + day;
                    return dateObj;
                }

                var preSize = new Date(year, parseInt(month) - 1, 0).getDate();//上月总天数
                if (preSize < parseInt(day)) {//上月总天数<本月日期，比如3月的30日，在2月中没有30
                    dateObj.last = year + '-' + month + '-01';
                    return dateObj;
                }

                if (parseInt(month) <= 10) {
                    dateObj.last = year + '-0' + (parseInt(month) - 1) + '-' + day;
                    return dateObj;
                } else {
                    dateObj.last = year + '-' + (parseInt(month) - 1) + '-' + day;
                    return dateObj;
                }

            },
            //获取经销商/门店
            getCust(val){
                console.log(val);
                if(val.dealer_sn){
                    this.form2.to_type = 2;
                    this.form3.to_type = 2;
                    this.form4.from_type = 2;
                    this.form5.from_type = 2;
                    this.form2.to_sn = val.dealer_sn;
                    this.form3.to_sn = val.dealer_sn;
                    this.form4.from_sn = val.dealer_sn;
                    this.form5.from_sn = val.dealer_sn;

                }else if(val.shop_sn){
                    this.form2.to_type = 3;
                    this.form3.to_type = 3;
                    this.form4.from_type = 3;
                    this.form5.from_type = 3;
                    this.form2.to_sn = val.shop_sn;
                    this.form3.to_sn = val.shop_sn;
                    this.form4.from_sn = val.shop_sn;
                    this.form5.from_sn = val.shop_sn;

                }
            },
            //获取仓库
            getStock(){
                this.$get('logistics','/warehouses.all', {
                    lang:''
                }).then(res => {
                    this.stockArray = res.data;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //入库统计列表
            getInstockData(){
                let beginstr = '', endstr = '';
                if(this.form1.start_time){
                    beginstr = this.moment(this.form1.start_time).format("YYYY-MM-DD")
                }
                if(this.form1.end_time){
                    endstr = this.moment(this.form1.end_time).format("YYYY-MM-DD");
                }
                this.loading = true;
                this.$get('logistics','/statistics/inwarehouses', {
                    lang:'',
                    start_time:beginstr,
                    end_time:endstr,
                    product_sn:this.form1.product_sn,
                    stock_in_sn:this.form1.stock_in_sn,
                    production_batch:this.form1.production_batch,
                    product_name:this.form1.product_name,
                    warehouse_sn:this.form1.warehouse_sn,
                    per_page:this.pageSize1,
                    page:this.pageNo1
                }).then(res => {
                    this.loading = false;
                    this.tableData1 = res.data;
                    this.totalSize1 = res.meta.total;
                    this.stock_in_num = res.stock_in_num;
                    this.real_stock_in_num = res.real_stock_in_num;
                }).catch(function (error) {
                    this.loading = false;
                    console.log(error);
                });

            },
            //入库统计列表导出
            instockExport(){
                let beginstr = '', endstr = '';
                if(this.form1.start_time){
                    beginstr = this.moment(this.form1.start_time).format("YYYY-MM-DD")
                }
                if(this.form1.end_time){
                    endstr = this.moment(this.form1.end_time).format("YYYY-MM-DD");
                }
                let url = '',access_tokens = localStorage.getItem('access_tokens');
              

                window.open(this.$Base_Export
                    +'/statistics/inwarehouses.export?start_time=' + beginstr +'&end_time=' + endstr +'&is_export=1'+ '&product_sn=' +
                    this.form1.product_sn +'&stock_in_sn=' + this.form1.stock_in_sn + '&production_batch=' + this.form1.production_batch+
                    '&product_name=' +this.form1.product_name + '&lang=' + ''+'&signature='+ this.$md5(access_tokens)

                )

            },
            //出库经销商/门店统计列表
            getOutstockDealerData(){
                let beginstr = '', endstr = '';
                if(this.form2.start_time){
                    beginstr = this.moment(this.form2.start_time).format("YYYY-MM-DD")
                }
                if(this.form2.end_time){
                    endstr = this.moment(this.form2.end_time).format("YYYY-MM-DD");
                }
                this.loading = true;
                this.$get('logistics','/statistics/out.dealers', {
                    lang:'',
                    start_time:beginstr,
                    end_time:endstr,
                    product_sn:this.form2.product_sn,
                    stock_out_sn:this.form2.stock_out_sn,
                    production_batch:this.form2.production_batch,
                    product_name:this.form2.product_name,
                    isgift:this.form2.isgift,
                    warehouse_sn:this.form2.warehouse_sn,
                    to_type:this.form2.to_type,
                    to_sn:this.form2.to_sn,
                    per_page:this.pageSize2,
                    page:this.pageNo2
                }).then(res => {
                    this.loading = false;
                    this.tableData2 = res.data;
                    this.totalSize2 = res.meta.total;
                    this.real_stock_out_num1 = res.real_stock_out_num;
                }).catch(function (error) {
                    this.loading = false;
                    console.log(error);
                });

            },
            //出库经销商/门店导出
            dealerOutstockExport(){
                let beginstr = '', endstr = '';
                if(this.form2.start_time){
                    beginstr = this.moment(this.form2.start_time).format("YYYY-MM-DD")
                }
                if(this.form2.end_time){
                    endstr = this.moment(this.form2.end_time).format("YYYY-MM-DD");
                }
                let url = '',access_tokens = localStorage.getItem('access_tokens');
             

                window.open(this.$Base_Export
                    +'/statistics/out.dealers.export?start_time=' + beginstr +'&end_time=' + endstr +'&is_export=1'+ '&product_sn=' +
                    this.form2.product_sn +'&stock_out_sn=' + this.form2.stock_out_sn + '&production_batch=' + this.form2.production_batch+
                    '&product_name=' +this.form2.product_name + '&lang=' + '' + '&warehouse_sn=' + this.form2.warehouse_sn +'&isgift=' +
                    this.form2.isgift+ '&to_type='+ this.form2.to_type+ '&to_sn='+ this.form2.to_sn+'&signature='+ this.$md5(access_tokens)

                )

            },
            //出库产品统计列表
            getOutstockGoodsData(){
                let beginstr = '', endstr = '';
                if(this.form3.start_time){
                    beginstr = this.moment(this.form3.start_time).format("YYYY-MM-DD")
                }
                if(this.form3.end_time){
                    endstr = this.moment(this.form3.end_time).format("YYYY-MM-DD");
                }
                this.loading = true;
                this.$get('logistics','/statistics/out.products', {
                    lang:'',
                    start_time:beginstr,
                    end_time:endstr,
                    product_sn:this.form3.product_sn,
                    stock_out_sn:this.form3.stock_out_sn,
                    production_batch:this.form3.production_batch,
                    product_name:this.form3.product_name,
                    isgift:this.form3.isgift,
                    warehouse_sn:this.form3.warehouse_sn,
                    to_type:this.form3.to_type,
                    to_sn:this.form3.to_sn,
                    per_page:this.pageSize3,
                    page:this.pageNo3
                }).then(res => {
                    this.loading = false;
                    this.tableData3 = res.data;
                    this.totalSize3 = res.meta.total;
                    this.real_stock_out_num2 = res.real_stock_out_num;
                }).catch(function (error) {
                    this.loading = false;
                    console.log(error);
                });
            },
            //出库产品导出列表
            productOutstockExport(){
                let beginstr = '', endstr = '';
                if(this.form3.start_time){
                    beginstr = this.moment(this.form3.start_time).format("YYYY-MM-DD")
                }
                if(this.form3.end_time){
                    endstr = this.moment(this.form3.end_time).format("YYYY-MM-DD");
                }
                let url = '',access_tokens = localStorage.getItem('access_tokens');
               

                window.open(this.$Base_Export
                    +'/statistics/out.products.export?start_time=' + beginstr +'&end_time=' + endstr +'&is_export=1'+ '&product_sn=' +
                    this.form3.product_sn +'&stock_out_sn=' + this.form3.stock_out_sn + '&production_batch=' + this.form3.production_batch+
                    '&product_name=' +this.form3.product_name + '&lang=' + '' + '&warehouse_sn=' + this.form3.warehouse_sn +'&isgift=' +
                    this.form3.isgift+ '&to_type='+ this.form3.to_type+ '&to_sn='+ this.form3.to_sn+'&signature='+ this.$md5(access_tokens)

                )
            },
            //退货经销商/门店列表
            getRefundDealerData(){
                let beginstr = '', endstr = '';
                if(this.form4.start_time){
                    beginstr = this.moment(this.form4.start_time).format("YYYY-MM-DD")
                }
                if(this.form4.end_time){
                    endstr = this.moment(this.form4.end_time).format("YYYY-MM-DD");
                }
                this.loading = true;
                this.$get('logistics','/statistics/returngoods.dealers', {
                    lang:'',
                    start_time:beginstr,
                    end_time:endstr,
                    product_sn:this.form4.product_sn,
                    return_goods_sn:this.form4.return_goods_sn,
                    warehouse_sn:this.form4.warehouse_sn,
                    product_name:this.form4.product_name,
                    isgift:this.form4.isgift,
                    from_type:this.form4.from_type,
                    from_sn:this.form4.from_sn,
                    per_page:this.pageSize4,
                    page:this.pageNo4
                }).then(res => {
                    this.loading = false;
                    this.tableData4 = res.data;
                    this.totalSize4 = res.meta.total;
                    this.real_return_goods_num = res.real_return_goods_num;
                }).catch(function (error) {
                    this.loading = false;
                    console.log(error);
                });
            },
            //导出退货列表
            refundDealerExport(){
                let beginstr = '', endstr = '';
                if(this.form4.start_time){
                    beginstr = this.moment(this.form4.start_time).format("YYYY-MM-DD")
                }
                if(this.form4.end_time){
                    endstr = this.moment(this.form4.end_time).format("YYYY-MM-DD");
                }
                let url = '',access_tokens = localStorage.getItem('access_tokens');
           

                window.open(this.$Base_Export
                    +'/statistics/returngoods.dealers.export?start_time=' + beginstr +'&end_time=' + endstr +'&is_export=1'+ '&product_sn=' +
                    this.form4.product_sn +'&return_goods_sn=' + this.form4.return_goods_sn + '&production_batch=' + this.form4.production_batch+
                    '&product_name=' +this.form4.product_name + '&lang=' + '' + '&warehouse_sn=' + this.form4.warehouse_sn +'&isgift=' +
                    this.form4.isgift+ '&from_type='+ this.form4.from_type+ '&from_sn='+ this.form4.from_sn+'&signature='+ this.$md5(access_tokens)

                )

            },
            //退货产品列表
            getRefundGoodsData(){

                let beginstr = '', endstr = '';
                if(this.form5.start_time){
                    beginstr = this.moment(this.form5.start_time).format("YYYY-MM-DD")
                }
                if(this.form5.end_time){
                    endstr = this.moment(this.form5.end_time).format("YYYY-MM-DD");
                }
                this.loading = true;
                this.$get('logistics','/statistics/returngoods.products', {
                    lang:'',
                    start_time:beginstr,
                    end_time:endstr,
                    product_sn:this.form5.product_sn,
                    warehouse_sn:this.form5.warehouse_sn,
                    return_goods_sn:this.form5.return_goods_sn,
                    product_name:this.form5.product_name,
                    isgift:this.form5.isgift,
                    from_type:this.form5.from_type,
                    from_sn:this.form5.from_sn,
                    per_page:this.pageSize5,
                    page:this.pageNo5
                }).then(res => {
                    this.loading = false;
                    this.tableData5 = res.data;
                    this.totalSize5 = res.meta.total;
                    this.real_return_goods_num = res.real_return_goods_num;

                }).catch(function (error) {
                    this.loading = false;
                    console.log(error);
                });
            },
            //退货产品导出
            refundGoodsExport(){
                let beginstr = '', endstr = '';
                if(this.form5.start_time){
                    beginstr = this.moment(this.form5.start_time).format("YYYY-MM-DD")
                }
                if(this.form5.end_time){
                    endstr = this.moment(this.form5.end_time).format("YYYY-MM-DD");
                }
                let url = '',access_tokens = localStorage.getItem('access_tokens');
          

                window.open(this.$Base_Export
                    +'/statistics/returngoods.products.export?start_time=' + beginstr +'&end_time=' + endstr +'&is_export=1'+ '&product_sn=' +
                    this.form5.product_sn +'&return_goods_sn=' + this.form5.return_goods_sn + '&production_batch=' + this.form5.production_batch+
                    '&product_name=' +this.form5.product_name + '&lang=' + '' + '&warehouse_sn=' + this.form4.warehouse_sn +'&isgift=' +
                    this.form5.isgift+ '&from_type='+ this.form5.from_type+ '&from_sn='+ this.form5.from_sn+'&signature='+ this.$md5(access_tokens)

                )
            },
            //库存统计列表
            getStockData(){
                this.loading = true;
                this.$get('logistics','/statistics/stocks', {
                    lang:'',
                    product_sn:this.form6.product_sn,
                    stock_in_sn:this.form6.stock_in_sn,
                    production_batch:this.form6.production_batch,
                    product_name:this.form6.product_name,
                    per_page:this.pageSize6,
                    page:this.pageNo6
                }).then(res => {
                    this.loading = false;
                    this.tableData6 = res.data;
                    this.totalSize6 = res.meta.total;
                    this.base_real_return_goods_num=res.real_return_goods_num;
                        this.base_real_stock_in_num = res.real_stock_in_num;
                        this.base_real_stock_out_num= res.real_stock_out_num;
                }).catch(function (error) {
                    this.loading = false;
                    console.log(error);
                });

            },
            //库存统计导出
            stockExport(){
                let url = '',access_tokens = localStorage.getItem('access_tokens');
           
                    console.log(url+process.env.VUE_APP_URL
                    +'/statistics/stocks.export?product_sn='+
                    this.form6.product_sn +'&stock_in_sn=' + this.form6.stock_in_sn + '&production_batch=' + this.form6.production_batch+
                    '&product_name=' +this.form6.product_name + '&lang=' + ''+'&signature='+ this.$md5(access_tokens)+'&is_export=1')
                
                window.open(this.$Base_Export
                    +'/statistics/stocks.export?product_sn='+
                    this.form6.product_sn +'&stock_in_sn=' + this.form6.stock_in_sn + '&production_batch=' + this.form6.production_batch+
                    '&product_name='+'&is_export=1' +this.form6.product_name + '&lang=' + ''+'&signature='+ this.$md5(access_tokens)
                )
            },
            //明细
            detail() {

            },
            //选择经销商/门店
            selectType() {
                this.selectRoleDialog = true;
            },
            //入库统计明细
            instockDetail(row) {
                this.stock_in_sn = row.stock_in_sn;
                this.instockDetailDialogVisable = true;

            },
            //出库客户明细
            outstockDetailCust(row) {
                  this.detaiData = row;
                this.outDetailDialogCustVisable = true;
            },
            //出库产品明细
            outstockDetailGoods(row) {
                this.product_sn = row.product_sn;
                this.outDetailDialogGoodsVisable = true;
            },
            //退货客户明细
            refundDetailCust(row) {
                this.refundCustData = row;
                this.refundDetailDialogCustVisable = true;
            },
            //退货产品明细
            refundDetailGoods(row) {
                this.refund_sn = row.product_sn;
                this.refundDetailDialogGoodsVisable = true;
            },
            //库存统计明细
            stockDetail(row){
                this.stockDetailDialogVisable = true;

            },
            handleClick1(tab, event) {
                //console.log(tab, event);
            },
            handleClick2(tab, event) {
                //console.log(tab, event);
            },
            handleClick3(tab, event) {
                //console.log(tab, event);
            },

            /*分页*/
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.pageNo1 = 1;
                this.getInstockData();
            },
            handleCurrentChange1(val) {
                this.pageNo1 = val;
                this.getInstockData();
            },

            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.pageNo2 = 1;
                this.getOutstockDealerData();
            },
            handleCurrentChange2(val) {
                this.pageNo2 = val;
                this.getOutstockDealerData();
            },
            handleSizeChange3(val) {
                this.pageSize3 = val;
                this.pageNo3 = 1;
                this.getOutstockGoodsData();
            },
            handleCurrentChange3(val) {
                this.pageNo3 = val;
                this.getOutstockGoodsData();
            },
            handleSizeChange4(val) {
                this.pageSize4 = val;
                this.pageNo4 = 1;
                this.getRefundDealerData();
            },
            handleCurrentChange4(val) {
                this.pageNo4 = val;
                this.getRefundDealerData();
            },
            handleSizeChange5(val) {
                this.pageSize5 = val;
                this.pageNo5 = 1;
                this.getRefundGoodsData();
            },
            handleCurrentChange5(val) {
                this.pageNo5 = val;
                this.getRefundGoodsData();
            },
            handleSizeChange6(val) {
                this.pageSize6 = val;
                this.pageNo6 = 1;
                this.getStockData();
            },
            handleCurrentChange6(val) {
                this.pageNo6 = val;
                this.getStockData();
            },

        },
        created() {
            this.form1.start_time = this.getLastMonth().last;
            this.form1.end_time = this.getLastMonth().now;
            this.form2.start_time = this.getLastMonth().last;
            this.form2.end_time = this.getLastMonth().now;
            this.form3.start_time = this.getLastMonth().last;
            this.form3.end_time = this.getLastMonth().now;
            this.form4.start_time = this.getLastMonth().last;
            this.form4.end_time = this.getLastMonth().now;
            this.form5.start_time = this.getLastMonth().last;
            this.form5.end_time = this.getLastMonth().now;
            this.getStock();
            //首次加载获取数据
            this.getInstockData();
            this.getOutstockDealerData();
            this.getOutstockGoodsData();
            this.getRefundDealerData();
            this.getRefundGoodsData();
            this.getStockData();

        },
        components: {
            selectRole, instockDetailDialog, outDetailDialogCust, outDetailDialogGoods,
            refundDetailDialogCust, refundDetailDialogGoods, stockDetailDialog
        }
    }
</script>
<style lang="scss" scoped>
</style>